import React from "react";
import moment from "moment";
import "moment/locale/id";

const prescriptionFields = [
    { key: "vitrumSperiesRight", label: "Vitrum Speries", aliases: ["r_sph"] },
    { key: "vitrumCylinderRight", label: "Vitrum Cylinder", aliases: ["r_cyl"] },
    { key: "axisRight", label: "Axis", aliases: ["r_axis"] },
    { key: "prismaBasisRight", label: "Prisma Basis", aliases: ["r_prismaBasis", "r_prisma"] },
    { key: "vitrumSperiesLeft", label: "Vitrum Speries", aliases: ["l_sph"] },
    { key: "vitrumCylinderLeft", label: "Vitrum Cylinder", aliases: ["l_cyl"] },
    { key: "axisLeft", label: "Axis", aliases: ["l_axis"] },
    { key: "prismaBasisLeft", label: "Prisma Basis", aliases: ["l_prismaBasis", "l_prisma"] },
    { key: "formaVitror", label: "Forma Vitror", aliases: ["fv", "frame"] },
    { key: "colorVitror", label: "Color Vitror", aliases: ["cv", "color"] },
    { key: "distantVitror", label: "Distant Vitror", aliases: ["dv"] }
];

function getFieldValue(section, field) {
    if (!section) return "";
    const value = section[field.key];
    if (value !== undefined && value !== null && String(value).trim() !== "") return value;

    if (field.aliases && field.aliases.length > 0) {
        for (const alias of field.aliases) {
            const aliasValue = section[alias];
            if (aliasValue !== undefined && aliasValue !== null && String(aliasValue).trim() !== "") {
                return aliasValue;
            }
        }
    }

    return "";
}

function MobilePrescriptionCard({ title, data }) {
    return (
        <div className="card mb-3">
            <div className="card-header py-2">
                <strong>{title}</strong>
            </div>
            <div className="card-body p-0">
                <table className="table table-sm mb-0">
                    <tbody>
                        {prescriptionFields.map((field) => (
                            <tr key={field.key}>
                                <th style={{ width: "45%" }}>{field.label}</th>
                                <td>{getFieldValue(data, field)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

function hasPrescriptionData(section) {
    return prescriptionFields.some((field) => {
        const value = getFieldValue(section, field);
        return value !== undefined && value !== null && String(value).trim() !== "";
    });
}

export default function EyePrescription({ patient, letter }) {
    const eyePrescription = letter ? letter.eyePrescription || letter.eyePrescripton || {} : {};
    const longinQuitat = eyePrescription.longinQuitat || {};
    const domo = eyePrescription.domo || {};
    const propinQuitat = eyePrescription.propinQuitat || {};
    const doctorName = letter && letter.onBehalfOf ? letter.onBehalfOf : "";
    const hasLonginQuitat = hasPrescriptionData(longinQuitat);
    const hasDomo = hasPrescriptionData(domo);
    const hasPropinQuitat = hasPrescriptionData(propinQuitat);
    const hasAnyPrescriptionData = hasLonginQuitat || hasDomo || hasPropinQuitat;

    return (
        <div>
            <h5 className="text-center">Resep Kacamata</h5>
            <table className="table table-sm">
                <tbody>
                    <tr>
                        <th>Nama</th>
                        <td>{patient.fullName}</td>
                    </tr>
                    <tr>
                        <th>Tanggal</th>
                        <td>{moment(letter.createdAt).format("dddd, DD-MM-YYYY")}</td>
                    </tr>
                    {doctorName.indexOf("dr.") > -1 && (
                        <tr>
                            <th>Dokter</th>
                            <td>{doctorName}</td>
                        </tr>
                    )}
                    <tr className="table-primary text-center">
                        <th colSpan={2}>Terverifikasi</th>
                    </tr>
                </tbody>
            </table>

            {hasAnyPrescriptionData && (
                <>
                    <div className="d-none d-md-block">
                        <div className="table-responsive">
                            <table className="table table-sm">
                                <thead>
                                    <tr>
                                        <td></td>
                                        {prescriptionFields.map((field) => (
                                            <td key={field.key}>{field.label}</td>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {hasLonginQuitat && (
                                        <tr>
                                            <td>Pro Longin Quitat</td>
                                            {prescriptionFields.map((field) => (
                                                <td key={field.key}>{getFieldValue(longinQuitat, field)}</td>
                                            ))}
                                        </tr>
                                    )}
                                    {hasDomo && (
                                        <tr>
                                            <td>Pro Domo</td>
                                            {prescriptionFields.map((field) => (
                                                <td key={field.key}>{getFieldValue(domo, field)}</td>
                                            ))}
                                        </tr>
                                    )}
                                    {hasPropinQuitat && (
                                        <tr>
                                            <td>Pro Propin Quitat</td>
                                            {prescriptionFields.map((field) => (
                                                <td key={field.key}>{getFieldValue(propinQuitat, field)}</td>
                                            ))}
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="d-md-none">
                        {hasLonginQuitat && <MobilePrescriptionCard title="Pro Longin Quitat" data={longinQuitat} />}
                        {hasDomo && <MobilePrescriptionCard title="Pro Domo" data={domo} />}
                        {hasPropinQuitat && <MobilePrescriptionCard title="Pro Propin Quitat" data={propinQuitat} />}
                    </div>
                </>
            )}
        </div>
    );
}
